mutation ResetCameraControlCounts($camControlId: ID!) {
  camControl: StreamToolsResetCameraControlCounts(camControlId: $camControlId) {
    camControlId
    commands {
      command
      count
    }
    currentCommandIndex
    streak
    version
  }
}
